import { auth } from '../firebase';
import { getIdToken } from 'firebase/auth';
import config from '../config';

export type ActivityType = 'session_start' | 'search' | 'page_view';

export const logActivity = async (type: ActivityType, metadata?: Record<string, any>) => {
  const user = auth.currentUser;
  if (!user) return;
  try {
    const token = await getIdToken(user);
    await fetch(`${config.API_BASE_URL}/api/activity`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ type, metadata: metadata || {} })
    });
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Activity log failed:', err);
    }
  }
};

export const logSessionStart = () => logActivity('session_start');
export const logSearch = (term?: string) => logActivity('search', term ? { term: term.slice(0, 100) } : {});
